import script from "./OrderStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStepper.vue?vue&type=script&setup=true&lang=js"

import "./OrderStepper.vue?vue&type=style&index=0&id=143335b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143335b4"]])

export default __exports__